import { IconWrapper } from './IconWrapper'
import { IIconProps } from './props'

export function PlayIcon(props: IIconProps) {
  return (
    <IconWrapper {...props}>
      <svg
        width="94"
        height="94"
        viewBox="0 0 94 94"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M47 0.6875C37.8403 0.6875 28.8862 3.40368 21.2702 8.49256C13.6541 13.5814 7.71813 20.8145 4.21285 29.277C0.707566 37.7395 -0.209576 47.0514 1.5774 56.0351C3.36438 65.0189 7.77522 73.271 14.2521 79.7479C20.7291 86.2248 28.9812 90.6356 37.9649 92.4226C46.9486 94.2096 56.2605 93.2924 64.723 89.7872C73.1855 86.2819 80.4186 80.3459 85.5075 72.7298C90.5963 65.1138 93.3125 56.1597 93.3125 47C93.2996 34.7211 88.4161 22.9489 79.7336 14.2664C71.0511 5.58397 59.2789 0.700467 47 0.6875ZM65.0574 49.9302L41.9012 65.9614C41.3666 66.3311 40.7411 66.5474 40.0924 66.5871C39.4436 66.6267 38.7964 66.4881 38.2208 66.1863C37.6451 65.8845 37.1631 65.431 36.8267 64.8749C36.4903 64.3187 36.3125 63.6812 36.3125 63.0312V30.9688C36.3125 30.3188 36.4903 29.6812 36.8267 29.1251C37.1631 28.569 37.6451 28.1155 38.2208 27.8137C38.7964 27.5119 39.4436 27.3733 40.0924 27.4129C40.7411 27.4526 41.3666 27.6689 41.9012 28.0386L65.0574 44.0698C65.5314 44.3976 65.9188 44.8354 66.1864 45.3458C66.4539 45.8561 66.5937 46.4238 66.5937 47C66.5937 47.5762 66.4539 48.1439 66.1864 48.6542C65.9188 49.1646 65.5314 49.6024 65.0574 49.9302Z"
          fill="white"
        />
      </svg>
    </IconWrapper>
  )
}
